import { section, color, align } from '@settings/common';

export function Schema({ article, blog, collection }) {
  if (article || blog || collection) return null;

  return {
    label: 'Product Comparison',
    key: 'product-comparison',
    fields: [
      {
        label: 'Text Settings',
        name: 'text',
        description: 'Heading, alignment',
        component: 'group',
        fields: [
          {
            label: 'Heading',
            name: 'heading',
            component: 'text',
            defaultValue: 'Undeniably Different',
          },
          {
            name: 'textAlign',
            label: 'Text align',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: align.options,
            defaultValue: align.value.center,
          },
        ],
      },
      {
        label: 'Brand Settings',
        name: 'brands',
        description: 'Configure brand names and images',
        component: 'group',
        fields: [
          {
            label: 'Your Brand Name',
            name: 'yourBrand',
            component: 'text',
            defaultValue: 'BrüMate',
          },
          {
            label: 'Your Brand Image',
            name: 'yourBrandImage',
            component: 'image',
          },
          {
            label: 'Your Brand column background color',
            name: 'yourBrandBgColor',
            component: 'select',
            options: [
              { label: 'Black', value: '#2c2c2c' },
              { label: 'Gray', value: '#f5f5f5' },
            ],
            defaultValue: '#2c2c2c',
          },
          {
            label: 'Competitor Brand Name',
            name: 'competitorBrand',
            component: 'text',
            defaultValue: 'Others',
          },
          {
            label: 'Competitor Brand Image',
            name: 'competitorBrandImage',
            component: 'image',
          },
          {
            label: 'Competitor column background color',
            name: 'competitorBgColor',
            component: 'select',
            options: [
              { label: 'Black', value: '#2c2c2c' },
              { label: 'Gray', value: '#f5f5f5' },
            ],
            defaultValue: '#f5f5f5',
          },
        ],
        defaultValue: {
          yourBrand: 'BrüMate',
          competitorBrand: 'Others',
        },
      },
      {
        label: 'Comparison Items',
        name: 'comparisonItems',
        description: 'Add comparison features',
        component: 'group-list',
        itemProps: (item) => ({
          key: item.id,
          label: item.title || 'New Comparison Item',
        }),
        defaultItem: () => ({
          id: Math.random().toString(36).substr(2, 9),
          title: '',
          description: '',
          yourBrandStatus: 'check',
          competitorStatus: 'cross',
        }),
        fields: [
          {
            label: 'Feature Title',
            name: 'title',
            component: 'text',
          },
          {
            label: 'Feature Description',
            name: 'description',
            component: 'text',
          },
          {
            label: 'Your Brand Status',
            name: 'yourBrandStatus',
            component: 'select',
            options: [
              { label: 'Check Mark', value: 'check' },
              { label: 'Cross Mark', value: 'cross' },
              { label: 'Partial Check', value: 'partial' },
            ],
          },
          {
            label: 'Competitor Status',
            name: 'competitorStatus',
            component: 'select',
            options: [
              { label: 'Check Mark', value: 'check' },
              { label: 'Cross Mark', value: 'cross' },
              { label: 'Partial Check', value: 'partial' },
            ],
          },
        ],
        defaultValue: [
          {
            id: '1',
            title: 'U-Turn™ leakproof lid',
            description:
              'Patented technology. Keep it open or locked & 100% leakproof',
            yourBrandStatus: 'check',
            competitorStatus: 'cross',
          },
          {
            id: '2',
            title: 'ColdKey™ stainless steel straw',
            description: 'Removable for easy cleaning',
            yourBrandStatus: 'check',
            competitorStatus: 'cross',
          },
          {
            id: '3',
            title: 'BevGuard™ technology',
            description: 'Keeps ice cold for 24+ hours',
            yourBrandStatus: 'check',
            competitorStatus: 'cross',
          },
          {
            id: '4',
            title: 'Reddot award winner',
            description: '',
            yourBrandStatus: 'check',
            competitorStatus: 'cross',
          },
          {
            id: '5',
            title: 'Cupholder-friendly',
            description: '',
            yourBrandStatus: 'check',
            competitorStatus: 'partial',
          },
          {
            id: '6',
            title: 'Dishwasher friendly',
            description: '',
            yourBrandStatus: 'check',
            competitorStatus: 'partial',
          },
        ],
      },
      {
        ...section,
        defaultValue: {
          bgColor: color.value.white,
          color: color.value.dark,
          desktop: {
            container: 'container',
            mt: 'l',
            py: 'xl',
          },
          mobile: {
            container: 'container',
            mt: 'm',
            py: 'l',
          },
        },
      },
    ],
  };
}
